var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from "redux-saga/effects";
import { UPLOAD_WEIGHT_DISPUTE_REQUEST, uploadWeightDisputeSuccess, uploadWeightDisputeFailure } from "../../actions";
import APIIN from "../../../utils/APIIN";
const WeightDisputeFileUpload = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        const { orderId, tenantId, file } = action.payload;
        try {
            APIIN.formUpload(`/report/admin/weight/dispute/upload?orderId=${orderId}&tenantId=${tenantId}`, {
                file: file,
            })
                .then((response) => {
                resolve(response);
            })
                .catch((error) => {
                reject(error);
            });
        }
        catch (error) {
            reject(error);
        }
    }));
});
function* weightDisputeFileUploadWorker(action) {
    try {
        const response = yield call(WeightDisputeFileUpload, action);
        yield put(uploadWeightDisputeSuccess(response));
    }
    catch (error) {
        if (error.response && error.response.data && error.response.data.message) {
            yield put(uploadWeightDisputeFailure(error.response.data.message));
        }
        else {
            yield put(uploadWeightDisputeFailure("An error occurred while uploading the file"));
        }
    }
}
export function* watchWeightDisputeFileUpload() {
    yield takeLatest(UPLOAD_WEIGHT_DISPUTE_REQUEST, weightDisputeFileUploadWorker);
}
